/* eslint-disable class-methods-use-this */
/* eslint-disable no-undef */
/* eslint no-restricted-globals: ["error", "event"] */

import { forEach } from 'underscore';
import CurrencyFormatter from '../../../../../utils/currency-formatter-lib';
import { FinalBalanceDue } from '../../../utils/final-balance-due';
import { orderStatus } from '../../../constants/orderStatus';
import DateHelper from '../../../../../utils/date-helper';
import DownloadBase64 from '../../../../../utils/download-base64';
import StringUtils from '../../../../../utils/string-utils';
import AnalyticsHelper from '../../../../../utils/analytics-helper';

export default class OrderStatus {
    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.el = parent.el.querySelector('.order-status');
        this.card = this.el.querySelector('.card-content');
        this.dealerUrl = this.parent.dealerUrl;
        this.retailerLinkContainer = this.parent.el.querySelector('.retailer-link-wrapper');
        this.retailerLink = this.retailerLinkContainer.querySelector('.retailer-link');
        this.retailerLink.href = '#';
        this.retailerLinkContainer.classList.add('hide');
        this.orderStatusWrapper = this.el.querySelector('#order-status-wrapper');
        var orderDropdownEl = parent.el.querySelector('#orderDropdown');
        if (orderDropdownEl) {
            var templateStr = orderDropdownEl.innerHTML.replace(/\\/g, '');
            this.orderIDTemplate = _.template(templateStr, { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g });
        } else {
            this.orderIDTemplate = null; // Prevent errors if element is missing
        }

        this.ctaPayDeposit = this.parent.el.querySelector('.pay-deposit-button');
        this.paymentLink = '#';
        this.orderSummaryTemplate = _.template(parent.el.querySelector('#order-summary').innerHTML.replaceAll('\\', ''));
        this.orderStatusInterestSubmitted = _.template(parent.el.querySelector('#order-status-interest-submitted').innerHTML.replaceAll('\\', ''));
        this.orderStatusAwaitingDeposit = _.template(parent.el.querySelector('#order-status-awaiting-deposit').innerHTML.replaceAll('\\', ''));
        this.orderStatusDepositPlaced = _.template(parent.el.querySelector('#order-status-deposit-placed').innerHTML.replaceAll('\\', ''));
        this.orderStatusOrderConfirmed = _.template(parent.el.querySelector('#order-status-order-confirmed').innerHTML.replaceAll('\\', ''));
        this.orderStatusOrderCancelled = _.template(parent.el.querySelector('#order-status-order-cancelled').innerHTML.replaceAll('\\', ''));
        this.orderStatusCancellationPending = _.template(parent.el.querySelector('#order-status-cancellation-pending').innerHTML.replaceAll('\\', ''));
        this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
        this.awaitingConfigurationConfirmationTemplate = this.getCompiledTemplate('#awaiting-configuration-confirmation');
        this.configurationConfirmedTemplate = this.getCompiledTemplate('#configuration-confirmed');
        this.awaitingB2CSalesContractSignatureTemplate = this.getCompiledTemplate('#awaiting-b2c-sales-contract-signature');
        this.b2CSalesContractSignedTemplate = this.getCompiledTemplate('#b2c-sales-contract-signed');
        this.handoverBookedTemplate = this.getCompiledTemplate('#handover-booked');
        this.finalBalanceDueTemplate = this.getCompiledTemplate('#final-balance-due');
        this.readyForHandoverTemplate = this.getCompiledTemplate('#ready-for-handover');
        this.handoverPendingTemplate = this.getCompiledTemplate('#handover-pending');
        this.handoverCompleteTemplate = this.getCompiledTemplate('#handover-complete');
        this.invalidOrderTemplate = this.getCompiledTemplate('#invalid-order');

        var orderStatusFallbackStr = parent.el.querySelector('#order-status-fallback')?.innerHTML.replace(/\\/g, '');
        this.orderStatusFallback = orderStatusFallbackStr ? _.template(orderStatusFallbackStr) : null;

        this.orderStatus = this.orderStatusFallback;
        this.statusesForExpectedHandoverDate = [orderStatus.interestSubmitted, orderStatus.awaitingDepositPayment, orderStatus.depositPlaced, orderStatus.orderConfirmed, orderStatus.orderCancelled, orderStatus.awaitingConfigurationConfirmation, orderStatus.configurationConfirmed, orderStatus.awaitingSalesContractSignature, orderStatus.salesContractSigned];
        this.statusesForHandoverDateTime = [orderStatus.handoverBooked, orderStatus.finalBalanceDue, orderStatus.readyForHandover, orderStatus.handoverComplete];

        this.utils = {
            formatPrice: new CurrencyFormatter().to,
            stringReplace: StringUtils.replace,
        };

        this.bind();
    }

    bind() {
        window.HONDA.MyAccount2.addEventListener('login', () => this.fetchOrder());
    }

    async fetchOrder() {
        this.orders = await window.HONDA.MyAccount2.client.getOrders();
        this.populateOrdersDropdown();
        this.populate();
    }

    async getPaymentLink(order) {
        const result = await window.HONDA.MyAccount2.client.getPaymentLink(order);
        const currentPage = [location.protocol, '//', location.host, location.pathname].join('');

        if (result?.paymentLink) {
            this.retailerLinkContainer.classList.add('hide');
            return `${result?.paymentLink}&successURL=${currentPage}&cancelURL=${currentPage}&pendingURL=${currentPage}`;
        }

        const link = await this.getDealerLink(order);
        this.retailerLink.href = link;
        this.retailerLinkContainer.classList.remove('hide');
    }

    getCompiledTemplate(selector) {
        var templateStr = this.parent.el.querySelector(selector)?.innerHTML.replace(/\\/g, '');
        return templateStr ? _.template(templateStr, this.templateSettings) : null;
    }

    populateOrdersDropdown() {
        if (this.orders?.length > 0) {
            this.orders.sort((a, b) => {
                if (a.orderStatus !== 'Order Cancelled' && b.orderStatus !== 'Order Cancelled') {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                }
                const x = a.orderStatus === 'Order Cancelled' ? 1 : 0;
                const y = b.orderStatus === 'Order Cancelled' ? 1 : 0;
                return x - y;
            });
            this.el.querySelector('.order-dropdown').innerHTML = this.orderIDTemplate({ orders: this.orders });
            this.bindOrdersDropdown();
        }
    }

    bindOrdersDropdown() {
        const self = this;
        this.el.querySelector('.card--order-no-options').addEventListener('change', (e) => {
            self.populate(e.currentTarget.selectedIndex);
        });
    }

    analyticsPushPaymentSuccess(order) {
        const documentCountryCode = document
        .querySelector('html')
        .getAttribute('country');
        const model = order?.summary?.ids?.modelCode;
        const totalPrice = order?.orderTotal;
        const mtoce = order?.summary?.ids?.mtoce;
        const selectedGrade = order?.summary?.ids?.gradeCode;
        const selectedColour = order?.summary?.ids?.colourCode;
        const orderId = order?.orderId;
        const taxPrice = order?.summary?.prices?.tax;
        const shippingPrice = order?.summary?.prices?.deliveryFee;
        const dealerName = order?.dealer?.dealerName;

        AnalyticsHelper.push({ ecommerce: null }); // Clear the previous ecommerce object.
        AnalyticsHelper.push({
            event: 'purchase',
            actionType: 'ecommerce - purchase',
            businessUnit: 'cars',
            moduleName: 'ecommerce',
            clickText: '',
            clickType: 'internal',
            destinationURL: '',
            modelSelected: model,
            inPageLocation: 'top',
            countryCode: documentCountryCode,
            ecommerce: {
                transaction_id: orderId,
                value: totalPrice,
                tax: taxPrice,
                shipping: shippingPrice,
                currency: window.HONDA?.currency?.ISO,
                items: [
                    {
                        item_id: mtoce,
                        item_name: model,
                        discount: 0,
                        index: 0,
                        item_brand: 'HONDA',
                        gradeName: selectedGrade,
                        colourName: selectedColour,
                        dealerName: dealerName,
                        price: totalPrice,
                        quantity: 1,
                    },
                ],
            },
        });
    }

    analyticsPushPageLoad(order) {
        if(this.router.path === '#dashboard'){
            AnalyticsHelper.push({
                event: 'order_select',
                eventCategory: 'my order',
                eventAction: 'select',
                eventLabel: `cars|${order?.summary?.ids?.modelCode}|My Account|${order?.summary?.ids?.modelCode}|dropdown|top||${order?.orderStatus}|${(order?.financeStatus ? order?.financeStatus : '')}`,
                actionType: 'select',
                businessUnit: 'cars',
                moduleName: 'My Account',
                destinationURL: '',
                clickText: order?.orderId,
                clickType: 'internal',
                modelSelected: order?.summary?.ids?.modelCode,
                inPageLocation: 'top',
                orderStatus: order?.orderStatus,
                financeStatus: (order?.financeStatus ? order?.financeStatus : ''),
                depositAmount: order?.dealStack?.holdingDeposit,
            });
        }
    }

    getDeliveryTime({ order, locale }) {
        const date = this.statusesForExpectedHandoverDate.includes(order.orderStatus) ? order.expectedHandoverDate : order.handoverDateTime;
        return DateHelper.getFormattedDate({ date, locale, dateTimeFormatOptions: { hour: '2-digit', minute: '2-digit', hour12: false } });
    }

    getDisplayDate({ order, locale }) {
        if (this.statusesForExpectedHandoverDate.includes(order.orderStatus) && order.expectedHandoverDate) {
            return DateHelper.getFormattedDate({
                date: order.expectedHandoverDate, locale, dateTimeFormatOptions: { month: 'long', year: 'numeric' },
            });
        }
        if (this.statusesForHandoverDateTime.includes(order.orderStatus) && order.handoverDateTime) {
            return DateHelper.getFormattedDate({
                date: order.handoverDateTime, locale: 'en-GB', dateTimeFormatOptions: {},
            });
        }
        return '';
    }

    hasPaymentQueryParam(order) {
        const queryParams = new URLSearchParams(location.search);
        const paymentStatus = queryParams.get('paymentStatus');
        const isAuthorised = paymentStatus === 'AUTHORISED';
        if (isAuthorised) {
            this.analyticsPushPaymentSuccess(order);
        }
        return isAuthorised;
    }

    hasNotAcceptedTerms(order) {
        return order.orderStatus === orderStatus.interestSubmitted && !localStorage.getItem('ma2-checkout-terms');
    }

    getOrderStatusTemplate(order) {
        if (order.status && order.status !== 'OK') {
            return this.invalidOrderTemplate;
        }

        if (order?.cancellationCase && order.orderStatus !== 'Order Cancelled') {
            return this.orderStatusCancellationPending;
        }

        const status = order.orderStatus;
        const template = {
            [orderStatus.interestSubmitted]: this.hasPaymentQueryParam(order) ? this.orderStatusAwaitingDeposit : this.orderStatusInterestSubmitted,
            [orderStatus.awaitingDepositPayment]: this.orderStatusAwaitingDeposit,
            [orderStatus.depositPlaced]: this.orderStatusDepositPlaced,
            [orderStatus.orderConfirmed]: this.orderStatusOrderConfirmed,
            [orderStatus.orderCancelled]: this.orderStatusOrderCancelled,
            [orderStatus.cancellationPending]: this.orderStatusCancellationPending,
            [orderStatus.awaitingConfigurationConfirmation]: this.awaitingConfigurationConfirmationTemplate,
            [orderStatus.configurationConfirmed]: this.configurationConfirmedTemplate,
            [orderStatus.awaitingSalesContractSignature]: this.awaitingB2CSalesContractSignatureTemplate,
            [orderStatus.salesContractSigned]: this.b2CSalesContractSignedTemplate,
            [orderStatus.handoverBooked]: this.handoverBookedTemplate,
            [orderStatus.finalBalanceDue]: this.finalBalanceDueTemplate,
            [orderStatus.readyForHandover]: this.readyForHandoverTemplate,
            [orderStatus.handoverPending]: this.handoverPendingTemplate,
            [orderStatus.handoverComplete]: this.handoverCompleteTemplate,
            fallback: this.orderStatusFallback,
        };

        return template[status] || template.fallback;
    }

    async getAdditionalData(order) {
        const htmlElement = document.getElementsByTagName('html')[0];
        const locale = htmlElement.getAttribute('lang');
        const additionalData = {
            estimatedDeliveryTime: this.getDisplayDate({ order, locale }),
            isValidOrderStatus: Object.values(orderStatus).includes(order.orderStatus),
            deliveryTime: this.getDeliveryTime({ order, locale }),
        };

        if (additionalData.isValidOrderStatus) {
            this.el.querySelector('.order-dropdown').classList.remove('hide');
        } else {
            this.el.querySelector('.order-dropdown').classList.add('hide');
        }

        switch (order.orderStatus) {
        case orderStatus.interestSubmitted:
            break;
        case orderStatus.awaitingConfigurationConfirmation:
            additionalData.link = order.links?.ssignDocs?.find((doc) => doc.type === 'Order Form')?.link;
            break;
        case orderStatus.awaitingSalesContractSignature:
            additionalData.link = order?.links?.ssignDocs?.find((doc) => doc.type === 'Customer Sales Contract')?.link;
            break;
        case orderStatus.handoverBooked:
            additionalData.link = await this.getDealerLink(order);
            break;
        case orderStatus.finalBalanceDue: {
            const finalBalanceDue = new FinalBalanceDue({ payments: order.payments });
            const {
                paymentDue, remainingBalance, ctaLink, isFinalInstalment, allPaymentsComplete, tabColours,
            } = finalBalanceDue.build();
            const documentFinalInvoice = order.documents.find((document) => document.documentType === 'Final Invoice');
            additionalData.document = documentFinalInvoice;
            additionalData.finalBalanceDue = {
                tabColours,
                paymentDue,
                remainingBalance,
                ctaLink,
                isFinalInstalment,
                nextPaymentNumber: finalBalanceDue.getIndexOfNextPayment() + 1,
                numberOfPayments: finalBalanceDue.payments.length,
                allPaymentsComplete,
            };
            break;
        }

        default:
            break;
        }

        return additionalData;
    }

    async postOrderStatusRender(order) {
        switch (order.orderStatus) {
        case orderStatus.interestSubmitted:
            this.bindFinanceQuoteLink(order);
            this.bindTermsAndCondition(order);
            this.bindPaymentLink(order);
            break;
        default:
            break;
        }
    }

    async getDealerLink(order) {
        const url = this.dealerUrl;
        const dealer = order.dealer.dealerCode;
        const result = await window.HONDA.MyAccount2.client.getDealerDetails(url, dealer);
        return result?.dealer?.alias;
    }

    bindFinanceQuoteLink(order) {
        const downloadQuoteLink = this.el.querySelector('.download-finance-quote');
        if (downloadQuoteLink && order.financeQuotePDFBase64) {
            downloadQuoteLink.addEventListener('click', (event) => {
                event.preventDefault();
                DownloadBase64.downloadPDF(order.financeQuotePDFBase64, `honda-finance-quote-${order.orderId}`);
            });
        }
    }

    bindTermsAndCondition(order) {
        const payDepositBtn = this.el.querySelector('.pay-deposit-button');
        const checkboxContainer = this.el.querySelector('.checkbox_container');
        if (this.hasNotAcceptedTerms(order) && payDepositBtn) {
            payDepositBtn.classList.add('disabled');
            checkboxContainer.classList.remove('hide');
            const checkboxes = [...this.el.querySelectorAll('.order-checkbox')];
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    const allChecked = checkboxes.every((c) => c.checked);
                    if (allChecked) {
                        payDepositBtn.classList.remove('disabled');
                    } else {
                        payDepositBtn.classList.add('disabled');
                    }
                });
            });
        }
    }

    bindPaymentLink(order) {
        const payDepositBtn = this.el.querySelector('.pay-deposit-button');
        if (payDepositBtn) {
            this.carOrderLoader = this.card.querySelector('#order-status-wrapper .form_builder_loader');
            payDepositBtn.addEventListener('click', async (event) => {
                event.preventDefault();
                this.carOrderLoader.classList.remove('hide');
                if (!payDepositBtn.classList.contains('disabled')) {
                    localStorage.setItem('ma2-checkout-terms', true);
                    const paymentLink = await this.getPaymentLink(order);
                    this.carOrderLoader.classList.add('hide');
                    window.location = paymentLink;
                }
            });
        }
    }

    async populate(selectedIndex) {
        const { utils } = this;

        if (this.orders?.length > 0) {
            const order = this.orders[selectedIndex || 0];
            this.el.classList.remove('hide');
            typeof window.newrelic?.addPageAction === 'function' && window.newrelic.addPageAction('myAccountOrderStatusRender', { action: 'show' });
            const additionalData = await this.getAdditionalData(order);
            this.card.innerHTML = this.orderSummaryTemplate({ order, additionalData, utils });
            this.orderStatus = this.getOrderStatusTemplate(order);
            this.card.querySelector('#order-status-wrapper').innerHTML = this.orderStatus({ order, additionalData, utils });
            this.analyticsPushPageLoad(order);
            await this.postOrderStatusRender(order);
        } else {
            this.el.classList.add('hide');
            typeof window.newrelic?.addPageAction === 'function' && window.newrelic.addPageAction('myAccountOrderStatusRender', { action: 'hide' });
        }
        this.parent.update();
    }

    parse(json) {
        try {
            return json ? JSON.parse(json) : {};
        } catch (err) {
            return {};
        }
    }
}
